export const exitCenterData = {
  stats: {
    total_surveys: 6,
    completed: 3,
    pending_hrbp: 1,
    pending_both: 1,
    pending_employee: 1
  },
  filters: {
    timeRange: "all",
    branch: "all",
    job: "all",
    rankBy: "exit_date"
  },
  rows: [
    {
      id: "1",
      exitDate: "05/16/2025",
      employee: {
        name: "Jason Yu",
        jobTitle: "Nurse",
        location: "Knoxville",
        locationIcon: "FeatherMeh",
        locationColor: "text-warning-800",
        region: "Appalachia"
      },
      tenure: "150d -180d",
      supervisor: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      exitType: "Voluntary",
      status: {
        variant: 'error',
        score: "Pending",
        subtext: "HRBP (13d)"
      }
    }
  ]
}; 